import React, { memo } from "react";
import { Grid, ButtonGroup, Typography } from "@mui/material";
import { blue, yellow } from "@mui/material/colors";
import PercentIcon from "@mui/icons-material/Percent";
import { useSelector } from "react-redux";
import { PERMISSIONS } from "router/permissions";
import RegularButton from "components/CustomButtons/Button";
import { ModalV2 } from "components/Modal/ModalV2";
import { UpdateInventoryDigitalInput } from "./UpdateInventoryDigitalInput";
import { useToggle } from "hooks/useToggle";

export const InventoriesActions = memo(
  ({ original, inventoryType, keyInventory, edited }) => {
    const [open, setOpen] = useToggle();
    const { inventory } = useSelector((state) => state.inventories);
    const { rules } = useSelector((state) => state.login);

    const isPending = original?.modificationRequestStatus === "PENDING";
    const editRule = rules.includes(
      PERMISSIONS.INVENTORIES_CONTROL_DIGITAL_UPDATE
    );

    return (
      <ButtonGroup sx={{ display: "flex", justifyContent: "flex-end" }}>
        {editRule && (
          <RegularButton
            justIcon
            round
            color="transparent"
            onClick={setOpen}
            disabled={inventory?.status === "CLOSED"}
            tooltip={
              isPending
                ? "Solicitud de modificación pendiente"
                : "Actualizar porcentaje digital"
            }
          >
            <PercentIcon sx={{ color: isPending ? yellow[900] : blue[900] }} />
          </RegularButton>
        )}
        <ModalV2
          open={open}
          onClose={setOpen}
          title="Actualizar porcentaje digital"
        >
          <Grid container>
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ mb: 1 }}>
                Unidad {original?.number}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <UpdateInventoryDigitalInput
                data={original}
                onClose={setOpen}
                inventoryType={inventoryType}
                keyInventory={keyInventory}
                edited={edited}
              />
            </Grid>
          </Grid>
        </ModalV2>
      </ButtonGroup>
    );
  }
);
